import { cloneElement, useState, useRef, useEffect } from '@wordpress/element';

const ImageCarouselProvider = ({
    images,
    ...props
}) => {

    const [imageCarouselState, setImageCarouselState] = useState({
        scroller: null,
        itemWidth: 0,
        currentIndex: 0,
        isPrevHidden: true,
        isNextHidden: false
    });

    const imageCarouselContainerPagesRef = useRef(null);
    const imageCarouselScrollerRef = useRef(null);

    const nextImage = () => {
        imageCarouselState.scroller.scrollBy({
            left: imageCarouselState.itemWidth, 
            top: 0, 
            behavior: 'smooth'
        });
    
        // Hide if is the last item
        setImageCarouselState({
            ...imageCarouselState,
            isNextHidden: true, 
            isPrevHidden: false
        });
    };

    const prevImage = () => {
        imageCarouselState.scroller.scrollBy({
            left: -imageCarouselState.itemWidth, 
            top: 0, 
            behavior: 'smooth'
        });
        
        setImageCarouselState({
            ...imageCarouselState, 
            isNextHidden: false, 
            isPrevHidden: true
        });
    };

    const scrollPages = index => {

        if (index > 2) {
            imageCarouselContainerPagesRef.current.scrollTo({
                left: 20 * (index - 2),
                top: 0, 
                behavior: 'smooth'
            });
        }

        if (index < 3) {
            imageCarouselContainerPagesRef.current.scrollTo({
                left: 0,
                top: 0, 
                behavior: 'smooth'
            });
        }
    };

    const scrollToIndex = (index) => {
        setImageCarouselState({
            ...imageCarouselState,
            currentIndex: index
        });

        imageCarouselState.scroller.scrollTo({
            left: imageCarouselState.itemWidth * index, 
            top: 0, 
            behavior: 'smooth'
        });

        scrollPages(index);
    };
    
    useEffect(() => {
        if (!imageCarouselScrollerRef) {
            return;
        }

        const scroller = imageCarouselScrollerRef.current;
        const itemWidth = imageCarouselScrollerRef.current.firstElementChild?.clientWidth;

        setImageCarouselState({
            ...imageCarouselState,
            scroller, 
            itemWidth
        });

        scroller.addEventListener('scrollend', () => {
            //Get scroll position and set current index
            const currentIndex = Math.round(scroller.scrollLeft / itemWidth);
            
            setImageCarouselState({
                ...imageCarouselState,
                scroller,
                itemWidth,
                currentIndex
            });

            scrollPages(currentIndex);
        });

    }, [images, imageCarouselScrollerRef]);


    return cloneElement(props.children, {
        ...props,
        images,
        imageCarouselContainerPagesRef,
        imageCarouselScrollerRef,
        imageCarouselState,
        setImageCarouselState,
        nextImage,
        prevImage,
        scrollToIndex
    });
};

export default ImageCarouselProvider;